import { s_check_circle, s_exclamation_circle, s_info_circle, s_times_circle } from '@fiverr-private/icons';
import { Button } from '@fiverr-private/fit';
import { MODES, THEMES } from './constants';
import classes from './index.module.scss';

/**
 * Supported theme configuration.
 * @type {Object<Object>}
 */
const THEME_CONFIG = {
    [THEMES.INFORMATION]: {
        icon: s_info_circle,
        actionButtonColor: Button.COLORS.BLUE,
        themeStyles: {
            [MODES.LIGHT]: {
                iconStyle: classes.informationIcon,
                themeStyle: classes.themeInformation
            },
            [MODES.DARK]: {
                iconStyle: classes.informationIconDark,
                themeStyle: classes.themeInformationDark
            }
        }
    },
    [THEMES.WARNING]: {
        icon: s_exclamation_circle,
        actionButtonColor: Button.COLORS.ORANGE,
        themeStyles: {
            [MODES.LIGHT]: {
                iconStyle: classes.warningIcon,
                themeStyle: classes.themeWarning
            },
            [MODES.DARK]: {
                iconStyle: classes.warningIconDark,
                themeStyle: classes.themeWarningDark
            }
        }
    },
    [THEMES.SUCCESS]: {
        icon: s_check_circle,
        actionButtonColor: Button.COLORS.GREEN,
        themeStyles: {
            [MODES.LIGHT]: {
                iconStyle: classes.successIcon,
                themeStyle: classes.themeSuccess
            },
            [MODES.DARK]: {
                iconStyle: classes.successIconDark,
                themeStyle: classes.themeSuccessDark
            }
        }
    },
    [THEMES.FAILURE]: {
        icon: s_times_circle,
        actionButtonColor: Button.COLORS.RED,
        themeStyles: {
            [MODES.LIGHT]: {
                iconStyle: classes.failureIcon,
                themeStyle: classes.themeFailure
            },
            [MODES.DARK]: {
                iconStyle: classes.failureIconDark,
                themeStyle: classes.themeFailureDark
            }
        }
    }
};

export default THEME_CONFIG;
